import { GetterTree } from 'vuex'
import { RootState } from 'store'
import { ApprovalGroupState } from './types'

export const getters: GetterTree<ApprovalGroupState, RootState> = {
    lsGroupApproval: (state: ApprovalGroupState) => state.lsGroupApproval,
    countGroupApproval: (state: ApprovalGroupState) => state.countGroupApproval,
    loading: (state: ApprovalGroupState) => state.loading,
}
